import React, { Component } from "react";
import Aux from "../../../../../hoc/Auxilliary";

class AssignmentResult extends Component {
  render() {
    return (
      <Aux>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12">
              <div className="row knowledge_check_bg01">
                <div className="container">
                  <div className="result_bg">
                    <div className="col-sm-6 col-sm-offset-3 col-xs-6 col-xs-offset-3">
                      <div className="row">
                        <h2>Congratulations!</h2>
                      </div>
                      <div className="row">
                        <div className="col-xs-6">
                          <h3>Your score is</h3>
                        </div>
                        <div className="col-xs-6">
                          <div className="c100 p50 big hidden-md hidden-sm hidden-xs">
                            <span>50%</span>
                            <div className="slice">
                              <div className="bar" />
                              <div className="fill" />
                            </div>
                          </div>
                          <div className="c100 p50 hidden-lg hidden-sm hidden-xs">
                            <span>50%</span>
                            <div className="slice">
                              <div className="bar" />
                              <div className="fill" />
                            </div>
                          </div>
                          <div className="c100 p50 small hidden-lg hidden-md">
                            <span>50%</span>
                            <div className="slice">
                              <div className="bar" />
                              <div className="fill" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <p>You have successfully completed the quiz program.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="bg">
          <img src="/images/tf_choose_video_image01.jpg" alt="" />
        </div>
      </Aux>
    );
  }
}

export default AssignmentResult;



// WEBPACK FOOTER //
// ./src/containers/User/Learning/Assignment/Result/Result.js